import styled from 'styled-components'
import {
    Container,
    Heading,
    Li,
    List, ModalMUI,
    ReadMore,
    Title, Title2,
} from '../sharedStyles'
import Tooltip from '@mui/material/Tooltip';
import { AcceptIcon } from '../../../../assets/icons/accept'
import { DotIcon } from '../../../../assets/icons/dot'
import { ImageList, ImageListItem, Typography } from '@mui/material'
import { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NotFound } from "./PersonalizedHealthEval";
import { ConfigText } from './HealthStatus'
import ReactDOM from 'react-dom';
import * as React from 'react';
import Button from '@mui/material/Button';
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import _ from "underscore";
import { resolveUploadUrl, fixUploadUrlsInHtml } from '../utils/appHelpers';

const Background = styled.div`
  width: 100%;
`

const Body = styled.div<{ active?: boolean }>`
  display: flex;
  transition: all .4s ease;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
  padding-bottom: 20px;
  
  @media print {
    background: #fff!important;
  }
`
const LeftSide = styled.div`
  width: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const RightSide = styled.div`
  margin-top: 12px;
  margin-left: 20px;
  padding-bottom: 30px;
  border-bottom: 1px solid #efefef;
  width: 100%;
`
const Number = styled.div<{ active?: boolean }>`
  height: 50px;
  width: 50px;
  margin: 0px auto;
  margin-top: 12px;
  background-color: ${({ active }) => (active ? '#C2EAED' : 'lightgray')};
  color: ${({ active }) => (active ? '#fff' : '#000')};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Roboto;
  font-size: 28px;
  font-weight: 500;
  line-height: 50px;
  letter-spacing: 0.48px;
  svg {
    width: 20px;
    height: 50px;
  }
`
const PuntoLine = styled.div`
  width: 50%;
  height: 100%;
  border-right: 1px dashed #ededed;
`

const Confirm = styled.div`
  margin-top: 10px;
  margin-left: 15px;
  position: relative;
  p,
  span {
    cursor: pointer;
    display: flex;
    align-items: start;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.28px;
  }
  span {
    color: var(--text-disabled, #bfbfbf);
  }
  p {
    color: var(--primary-40, #3baab0);
  }
  svg {
    position: absolute;
    left: -20px;
  }
`

const Text = styled.div`
  display: grid;
  align-items: start;
  justify-items: center;
  grid-template-columns: 20px calc(100% - 10px);
`

const FilePreviewItem = ({ item, ind }: { item: any, ind?: number }) => {
    const { i18n } = useTranslation()
    let it = item;

    if (!it) {
        return null;
    }

    const getLocalizedText = (text: any): string => {
        if (!text) return '';
        if (typeof text === 'string') return text;
        if (typeof text === 'object') {
            const currentLanguage = i18n.language;
            return text[currentLanguage] || text.en || Object.values(text)[0] || '';
        }
        return '';
    };

    const localizedShortTitle = getLocalizedText(it.shortTitle);
    const localizedTitle = getLocalizedText(it.title);

    return (
        <div key={ind} className={'image-content-wrap'}>
            <div key={ind} className={'image-content'}>
                <Tooltip
                    placement="bottom"
                    className="border border-blue-gray-50 bg-white px-4 py-3 shadow-xl shadow-black/10"
                    title={
                        localizedTitle || localizedShortTitle ? <div className="w-80">
                            {localizedShortTitle && <div className={'tooltipShortTitle'}>
                                {localizedShortTitle}
                            </div>}
                            {localizedTitle && <div className={'tooltipTitle'}>
                                {localizedTitle}
                            </div>}
                        </div> : ''
                    }
                    arrow
                >
                    <img src={resolveUploadUrl(it.url)} alt={localizedTitle || '-'} />
                </Tooltip>
            </div>
        </div>)
}

const RecommendationsText = ({
    isLast,
    item,
    index,
}: {
    item: any[]
    index: number
    isLast?: boolean
}) => {
    const { t, i18n } = useTranslation()
    const [openObj, setOpenObj] = useState({})

    // In frozen report mode, all steps are "confirmed"
    const currentRecommendationStep = 999

    const isActive = currentRecommendationStep >= index

    const getLocalizedText = (text: any): string => {
        if (!text) return '';
        if (typeof text === 'string') return text;
        if (typeof text === 'object') {
            const currentLanguage = i18n.language;
            return text[currentLanguage] || text.en || Object.values(text)[0] || '';
        }
        return '';
    };

    let arr = _.sortBy(item, it => (+it?.sortingValue?.name || 1))

    if (arr && arr.length) {
        let filtered = arr.filter(it => it?.info?.isOneInList)
        if (filtered.length) {
            arr = [filtered[0]]
        }
    }

    return (
        <Body className={'recommendation-body ' + (!isActive ? 'blurOverlay' : '')} active={isActive}>
            <LeftSide>
                <Number className='number' active={isActive}>
                    {isActive ? <AcceptIcon color='#0D6C71' /> : index + 1}
                </Number>
                <PuntoLine />
            </LeftSide>
            <RightSide data-right-recommendation>
                {(arr || []).map((item: any, index: any) => {
                    let isName = Boolean(item?.name)
                    let isFiles = Boolean(item?.files?.length)
                    let fullFiles = item.files;
                    let leng = fullFiles?.length || 0;
                    let hiddenCount = Math.max(leng - 4, 0);
                    let visibleFiles = (fullFiles || []).slice(0, 4);
                    let isShort = leng > 4;
                    let isOpenBool = ((openObj || {}) as any)[index] || !isShort;

                    const description = getLocalizedText(item.description);
                    const name = getLocalizedText(item.name);

                    return <div className={'disDesc' + (!isName ? ' woNameWrap ' : '') + (index ? ' secondWrap ' : '')}>
                        {isName && <div className={'recommendation-title'}>{name}</div>}
                        <div>
                            {description && <TextLinkify text={description}></TextLinkify>}

                            {isFiles && !isOpenBool && <div className={'fileImgWrap'}>
                                <div className="ibHorizontal">
                                    <div className="ibHorizontal2">
                                        <div className="ibLineWrap">
                                            {(visibleFiles || []).map((file: any, idx: number) => (
                                                <div className="childLine" key={idx}>
                                                    <FilePreviewItem item={file}></FilePreviewItem>
                                                </div>
                                            ))}
                                            {hiddenCount > 0 && (
                                                <div className="childLine">
                                                    <div className="plusTextWrap" onClick={() => {
                                                        setOpenObj({ ...openObj, [index]: true })
                                                    }}>
                                                        <div className="plusText">
                                                            +{hiddenCount}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>}


                            {isOpenBool && isFiles && <><div className={'fileImgWrap gr-container'}>
                                {(fullFiles || []).map((it: any, ind: number) => {
                                    return (<div key={ind} className={'fileImg'}>
                                        <div className={'image-container'}>
                                            <div className={'image-content'}>
                                                <FilePreviewItem item={it}></FilePreviewItem>
                                            </div>
                                        </div>
                                    </div>)
                                })}
                            </div>
                                {isShort && <div style={{ width: '100%', display: 'block', marginTop: '10px' }}>
                                    <a onClick={() => {
                                        setOpenObj({ ...openObj, [index]: false })
                                    }}>Collapse images</a>
                                </div>}
                            </>}
                        </div>
                    </div>
                })}
                <div style={{ marginTop: '30px', display: 'block', width: '100%' }}>
                </div>
                <Confirm>
                    <span data-fade>
                        <AcceptIcon color='#BFBFBF' /> Read
                    </span>
                </Confirm>
            </RightSide>
        </Body>
    )
}

export function tooltipElement(element: any) {
    if (!/tooltipChild/gi.test(element.innerHTML)) {
        element.className = 'titleDescription'
        let ww = window.innerWidth
        let title = element.getAttribute('data-tooltip-title');

        let tooltipFakeEl = document.createElement('div') as HTMLElement
        tooltipFakeEl.innerHTML = `<div>${title}</div>`;
        tooltipFakeEl.className = 'fakeElForWidth'
        tooltipFakeEl.style.opacity = "1";
        tooltipFakeEl.style.display = "block";

        let body = document.body;
        body.appendChild(tooltipFakeEl);

        let tooltipWidth = tooltipFakeEl.clientWidth;
        body.removeChild(tooltipFakeEl)
        let windowWidth = document.querySelector('[data-header-content]')?.clientWidth || window.innerWidth;

        element.innerHTML = element.innerHTML + `<div class="tooltipChild" data-info="${JSON.stringify(element.getBoundingClientRect())}" 
            style="max-width: ${Math.min(ww, (tooltipWidth + 5), 350)}px"><div>${element.getAttribute('data-tooltip-title')}</div</div>`
        let tooltip = element.querySelector('.tooltipChild') as HTMLElement | null;

        if (tooltip) {
            var tooltipRect = tooltip.getBoundingClientRect();
            var parentRect = element.getBoundingClientRect();

            let isRight = (parentRect.left > windowWidth / 2) && ((parentRect.left + tooltipWidth) > (windowWidth - 20));
            element.setAttribute('is-data-right', isRight)
            if (isRight) {
                tooltip.style.right = 10 + 'px';
            } else {
                tooltip.style.left = (10) + 'px';
            }
        }
    }
}

export const TextLinkify = ({ text }: { text: string }) => {
    let [isRead, setIsRead] = useState(false)
    const contentRef = useRef(null);

    React.useEffect(() => {
        try {
            let els = (contentRef?.current as any).querySelectorAll('[data-tippy-content]')
            tippy(els, {
                maxWidth: 350,
                arrow: true,
                delay: [100, 100],
                theme: 'light',
            });
        } catch (e) {
        }
    })

    if (!text || typeof text !== 'string') {
        return <></>
    }
    let readMoreClassName = 'readMoreClickBtn'
    let readMoreReg = /\{\{readmore\}\}/gi;
    let readMoreReg2 = /\@\@/gi;

    text = text.replace(readMoreReg, '@@')
    let __html = fixUploadUrlsInHtml(
        text
            .replace(/\{\{(.+?)\|(.+?)\}\}/gi, (...args: any[]) => {
                if (args[1].indexOf('}}') > -1) {
                    return args[0]
                }
                return `<span data-tippy-content="${args[2]}" class="has-tooltip2 titleDescription">${args[1]}</span>`
            })
    )
    __html = __html.replace(readMoreReg2, '{{readmore}}')
    let arr = __html.split(readMoreReg);
    let isReadMore = arr[1];


    function addReadMoreToLastTag(htmlString: any, title: string) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;

        let lastChild: any = tempDiv.lastElementChild;
        while (lastChild && lastChild.nodeType !== 1) {
            lastChild = lastChild.previousSibling;
        }

        const space5px = document.createElement('span')
        space5px.innerHTML = ' ';

        let tagName = lastChild?.tagName;
        if (lastChild) {
            const readMoreLink = document.createElement('a');
            readMoreLink.textContent = title;
            readMoreLink.className = readMoreClassName;

            if (tagName === 'UL') {
                readMoreLink.setAttribute('data-mt-ul', '1')
                tempDiv.appendChild(readMoreLink);
            } else {
                lastChild.appendChild(space5px);
                lastChild.appendChild(readMoreLink);
            }
        }

        return tempDiv.innerHTML;
    }

    let toggle = (e: any, v: boolean) => {
        const target = e.target as HTMLElement;
        if (target.className === readMoreClassName) {
            setIsRead(v)
        }
    }


    let fullHTML = __html.replace(readMoreReg, '');

    return <>
        {isRead || !isReadMore ? <><span
            ref={contentRef}
            onClick={(e) => {
                toggle(e, false)
            }}
            dangerouslySetInnerHTML={{
                __html: isRead ? addReadMoreToLastTag(fullHTML, 'Read less') : fullHTML
            }}></span>
        </> : <>
            <span
                ref={contentRef}
                dangerouslySetInnerHTML={{ __html: addReadMoreToLastTag(arr[0], 'Read more') }} onClick={(e) => {
                    toggle(e, true)
                }}></span>
        </>}
    </>
}


export const RecomendAndNextSteps = (props: any) => {
    const { t, i18n } = useTranslation()
    const [isModalOpen, setIsModalOpen] = useState(false)

    let { themeId } = props
    const { info } = props
    const recommendations = themeId
        ? info.recommendations.filter((it: any) => {
            const subjectId = (it.subjectIds || [])[0];
            return themeId == subjectId
          })
        : info.recommendations;

    const subject = info?.subjects?.find((it: any) => it._id == themeId) || {}
    const bibliographyRaw = subject.bibliography
    const getLocalizedBibliography = (raw: any): string => {
        if (!raw) return ''
        if (typeof raw === 'string') return raw
        if (typeof raw === 'object') {
            const currentLanguage = i18n.language
            return raw[currentLanguage] || raw.en || raw.de || (Object.values(raw)[0] as string) || ''
        }
        return ''
    }
    const bibliographyHtml: string = getLocalizedBibliography(bibliographyRaw)
    return (
        <div style={{ background: '#fff' }}>
            <Background data-animch className={'padd paddRec'}>
                <div className='recommendation-container' data-animch='3'>
                    <Title2>
                        <ConfigText field={'recommendations_and_next_steps'}>
                            {t('recommendationsAndNextSteps')}</ConfigText></Title2>

                    {recommendations.length === 0 && (<NotFound />
                    )}
                    {(recommendations || [])
                        .map((it: any, index: number) => {
                            return <RecommendationsText key={index} index={index} item={[it]} />
                        })}
                    {!!bibliographyHtml?.length && <>
                        <a style={{ marginTop: '30px' }} onClick={() => {
                            setIsModalOpen(true)
                        }}>{t('bibliography')}</a>
                        {isModalOpen && <><div
                            style={{ animationDelay: '0s' }}
                            className={'disDesc'}
                            dangerouslySetInnerHTML={{ __html: fixUploadUrlsInHtml(bibliographyHtml) }}></div>
                            <div style={{ marginTop: '25px' }}>
                                <a onClick={() => setIsModalOpen(false)}>Hide bibliography</a>
                            </div>
                        </>}
                    </>}
                </div>

            </Background>
        </div>
    )
}

export default RecomendAndNextSteps
